import { ADD_LIABILITY, REMOVE_LIABILITY } from '../constants/actionTypes';
import { liabilityKey } from '../pages/HasDebtPage/HasDebtHelpers';

const initialState = [];

function removeItemWithKey(reduxState, payload) {
  const newState = reduxState.filter(liability => {
    const idString = liabilityKey(liability);
    return idString !== payload;
  });
  return newState;
}

function liabilities(state = initialState, action) {
  const { type, payload } = action;
  if (type === ADD_LIABILITY) {
    return [...state, payload];
  }

  if (type === REMOVE_LIABILITY) {
    return removeItemWithKey(state, payload);
  }
  return state;
}
export default liabilities;
